import { TeamTasks } from '@/modules/teams/team-tasks'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_internal/teams/$teamId/todos')({
  component: TeamTodosPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      status: search.status as string | undefined,
      search: search.search as string | undefined,
      assigneeId: Array.isArray(search.assigneeId)
        ? search.assigneeId
        : search.assigneeId
          ? [search.assigneeId]
          : undefined,
    }
  },
})

function TeamTodosPage() {
  const { teamId } = Route.useParams()

  return (
    <div>
      <h2 className="mb-4 text-2xl font-bold">Team Todos</h2>
      <TeamTasks teamId={teamId} />
    </div>
  )
}
